import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import ActionButton from './ActionButton';
import DatePicker from './DatePicker';
import GroupedTripSelector from './GroupedTripSelector';
import Pricing from './Pricing';
import QuantitySelector from './QuantitySelector';
import SwapBlock from './SwapBlock';
import Loader from './Loader';

const Container = styled.div`
  position: relative;
  padding: 24px 16px;
  p {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

const OuterContainer = styled.div`
  position: relative;
`;

const RequestBook = ({
  onChangeCustomize,
  customize,
  openCustomizeQty,
}) => {
  return (
    <OuterContainer>
      <Container>
        <DatePicker />
        <SwapBlock />
        <GroupedTripSelector />
        <QuantitySelector onChangeCustomize={onChangeCustomize} />
        <Pricing customize={customize} />
        <ActionButton
          customize={customize}
          openCustomizeQty={openCustomizeQty}
        />
      </Container>
      <Loader />
    </OuterContainer>
  );
};

RequestBook.propTypes = {
  onChangeCustomize: PropTypes.func,
  customize: PropTypes.bool,
  openCustomizeQty: PropTypes.func,
};

export default RequestBook;
